import { createEntityAdapter } from '@reduxjs/toolkit';
import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';

export const membersAdapter = createEntityAdapter<DialogMemberViewModel>();
